export default __webpack_public_path__ + "static/media/inventory-dashboard.cce39469.jpg";